import React from "react";
import { Heart } from "lucide-react";

export default function TeacherDetailVisitLogSection({
  editingLogId,
  isMobile,
  logInputContent,
  logInputDate,
  logInputSentiment,
  logInputType,
  onAddLog,
  onUpdateLog,
  openAlert,
  setEditingLogId,
  setLogInputContent,
  setLogInputDate,
  setLogInputSentiment,
  setLogInputType,
  teacher,
  userProfile,
}) {
  const currentMemberRole = userProfile?.memberRole;
  const myUid = userProfile?.uid || userProfile?.id;
  const isLinkedUser = myUid && teacher.linkedUserId && String(teacher.linkedUserId) === String(myUid);
  const isMyProfile = isLinkedUser;
  const shouldMask = currentMemberRole === "teacher" && !isMyProfile;

  if (shouldMask || !isMobile) {
    return null;
  }

  return (
    <div className="w-full space-y-1 mb-8">
      <div className="flex items-center justify-between mb-2 px-1">
        <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
          <Heart size={20} className="fill-orange-400 text-orange-400" />
          {editingLogId ? "심방 기록 수정" : "심방 일지"}
        </h3>
        {editingLogId && (
          <button
            onClick={() => {
              setEditingLogId(null);
              setLogInputContent("");
              setLogInputType("면담");
              setLogInputDate(new Date().toISOString().split("T")[0]);
              setLogInputSentiment("neutral");
            }}
            className="text-xs font-bold text-gray-400 hover:text-rose-500 transition"
          >
            취소
          </button>
        )}
      </div>

      <div className={`rounded-[2rem] p-5 shadow-sm border ${editingLogId ? "bg-orange-50 border-orange-200" : "bg-gray-50 border-gray-100"}`}>
        <div className="flex gap-2 mb-3 flex-wrap">
          {["면담", "전화", "문자", "기도", "교제"].map((type) => (
            <button
              key={type}
              onClick={() => setLogInputType(type)}
              className={`px-3 py-1.5 rounded-full text-xs font-bold transition ${logInputType === type
                ? "bg-orange-500 text-white shadow-sm"
                : "bg-white text-gray-500 hover:bg-gray-100 shadow-sm border border-gray-100"
                }`}
            >
              {type}
            </button>
          ))}
        </div>
        <div className="flex gap-2">
          <input
            type="text"
            value={logInputContent}
            onChange={(e) => setLogInputContent(e.target.value)}
            placeholder="심방 내용을 간단히 기록해주세요..."
            className="flex-1 px-4 py-3 bg-white rounded-2xl text-sm font-medium focus:outline-none focus:ring-2 focus:ring-orange-200 border border-gray-100"
          />
          <button
            onClick={() => {
              if (!logInputContent.trim()) {
                openAlert("내용을 입력해주세요.", "알림");
                return;
              }

              if (editingLogId) {
                if (onUpdateLog) {
                  onUpdateLog({
                    id: editingLogId,
                    teacherId: teacher.id,
                    teacherName: teacher.name,
                    type: logInputType,
                    content: logInputContent,
                    date: logInputDate,
                    sentiment: logInputSentiment,
                  });
                  setLogInputContent("");
                  setEditingLogId(null);
                  openAlert("심방 기록이 수정되었습니다! ✏️", "완료");
                }
              } else if (onAddLog) {
                onAddLog({
                  teacherId: teacher.id,
                  teacherName: teacher.name,
                  type: logInputType,
                  content: logInputContent,
                  date: logInputDate,
                  sentiment: logInputSentiment,
                  createdAt: new Date().toISOString(),
                  createdBy: userProfile?.id || "unknown",
                  createdByName: userProfile?.name || "알 수 없음",
                });
                setLogInputContent("");
                openAlert("심방 기록이 저장되었습니다! 🙏", "완료");
              }
            }}
            className="px-4 py-3 bg-orange-500 text-white rounded-2xl font-bold text-sm flex items-center gap-1 shadow-lg shadow-orange-500/20 active:scale-95 transition whitespace-nowrap"
          >
            {editingLogId ? "수정" : "저장"}
          </button>
        </div>
      </div>
    </div>
  );
}
